// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as React from "react";
import * as Caml_array from "@rescript/std/lib/es6/caml_array.js";
import * as Caml_int32 from "@rescript/std/lib/es6/caml_int32.js";
import * as JsxRuntime from "react/jsx-runtime";
import ReactTextTransition from "react-text-transition";

function TextTransition(props) {
  var className = props.className;
  var noOverflow = props.noOverflow;
  var inline = props.inline;
  var direction = props.direction;
  var delay = props.delay;
  var textArr = props.textArr;
  var delay$1 = delay !== undefined ? delay : 3000;
  var direction$1 = direction !== undefined ? direction : "up";
  var inline$1 = inline !== undefined ? inline : false;
  var noOverflow$1 = noOverflow !== undefined ? noOverflow : false;
  var className$1 = className !== undefined ? className : "";
  var match = React.useState(function () {
        return 0;
      });
  var setIndex = match[1];
  var index = match[0];
  var match$1 = React.useState(function () {
        return Caml_array.get(textArr, 0);
      });
  var setText = match$1[1];
  React.useEffect((function () {
          var intervalId = setInterval((function (param) {
                  Curry._1(setIndex, (function (prevIndex) {
                          return prevIndex + 1 | 0;
                        }));
                }), delay$1);
          return (function (param) {
                    clearInterval(intervalId);
                  });
        }), []);
  React.useEffect((function () {
          Curry._1(setText, (function (param) {
                  return Caml_array.get(textArr, Caml_int32.mod_(index, textArr.length));
                }));
        }), [index]);
  return JsxRuntime.jsx(ReactTextTransition, {
              text: match$1[0],
              direction: direction$1,
              inline: inline$1,
              delay: index === 0 ? 0 : delay$1,
              springConfig: props.springConfig,
              noOverflow: noOverflow$1,
              className: className$1
            });
}

var make = TextTransition;

export {
  make ,
}
/* react Not a pure module */
